import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
const isReady = () => {
    var _a;
    return (typeof window !== 'undefined' &&
        typeof window.grecaptcha !== 'undefined' &&
        typeof ((_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.execute) !== 'undefined');
};
let readyCheck;
const ReCaptcha = ({ elementID = 'g-recaptcha', verifyCallbackName = 'verifyCallbackName', sitekey, action, verifyCallback, }) => {
    const [ready, setReady] = useState(isReady());
    const updateReadyState = () => {
        if (isReady()) {
            setReady(true);
            clearInterval(readyCheck);
        }
    };
    useEffect(() => {
        const execute = () => {
            var _a, _b;
            if (ready) {
                (_b = (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.execute) === null || _b === void 0 ? void 0 : _b.call(_a, sitekey, { action }).then((token) => {
                    if (typeof verifyCallback !== 'undefined') {
                        verifyCallback(token);
                    }
                }).catch((e) => {
                    console.log(e);
                });
            }
        };
        if (ready) {
            execute();
        }
        else {
            readyCheck = window.setInterval(updateReadyState, 1000);
        }
        //cleanup function to run when component unmounted
        return () => {
            clearInterval(readyCheck);
        };
    }, [ready]);
    return ready ? (_jsx("div", { id: elementID, "data-verifycallbackname": verifyCallbackName })) : (_jsx("div", { id: elementID, className: 'g-recaptcha' }));
};
export default ReCaptcha;
